import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { catchError } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { OrganizationService } from './organization.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  getUser() {
    try {
      let token = localStorage.getItem('id_token');
      if(token) {
        let decoded:any = jwtDecode(token);
        return decoded['id'];
      }
    } catch(e) {
    }
    return '';
  }

  log(message: any, ...optionalParams: any[]) {
    console.log(message, ...optionalParams);
    // send http post to server
    let rid: string = uuidv4();
    const apiPrefix = this.organizationService.getApiPrefix();
    this.http.post(`${apiPrefix}/applog/${rid}`, { t: 'log', m: message, d: this.deviceId, i: this.id, p: optionalParams, u: this.getUser() })
    .subscribe({
      next: (v) => console.log('log sent', v),
      error: (e) => console.error('log failed', e.status)
    });
  } 

  error(message: any, ...optionalParams: any[]) {
    console.error(message, ...optionalParams);
    // send http post to server
    let rid: string = uuidv4();
    const apiPrefix = this.organizationService.getApiPrefix();
    this.http.post(`${apiPrefix}/applog/${rid}`, { t: 'error', m: message, d: this.deviceId, i: this.id, p: optionalParams, u: this.getUser() })
    .subscribe({
      next: (v) => console.log('error sent', v),
      error: (e) => console.error('error failed', e.status)
    });
  } 

  warn = console.warn.bind(console.warn);
  debug = console.debug.bind(console.debug);

  id: string = uuidv4();
  deviceId: string = localStorage.getItem('device_id') || '';

  constructor(
    private http: HttpClient,
    private organizationService: OrganizationService
  ) {
    // get device id from local storage
    this.deviceId = localStorage.getItem('device_id') || '';
    if(!this.deviceId) {
      // generate new device id
      this.deviceId = uuidv4();
      localStorage.setItem('device_id', this.deviceId);
    }
    this.log('LogService created, instance = ' + this.id + ", device = " + this.deviceId);
  }

}
